var map = {
	"./aastra.jpg": 563705,
	"./grandstream.jpg": 917719,
	"./jami.jpg": 173744,
	"./linphone.jpg": 809518,
	"./microsip.jpg": 41589,
	"./panasonic.jpg": 897339,
	"./unknown.jpg": 395431,
	"./yealink.jpg": 390450,
	"./zoiper.jpg": 610050
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42204;